import { hasProperty } from "@/js/utils";

export class DisasterClass {
  static T = "T";
  static P = "P";
  static NAMES = {
    T: "訓練",
    P: "実災害"
  };
  static TAB_ID_LIST = {
    T: "tab-training",
    P: "tab-production"
  };
  constructor(value) {
    this.value = value;
  }
  static factory(value) {
    return new DisasterClass(value);
  }
  static getDisasterName(value, disasterName) {
    if (value === DisasterClass.T) {
      return `【訓練】${disasterName}`;
    }
    return disasterName;
  }
  static getTabId(disaster) {
    if (
      disaster &&
      hasProperty(disaster, "disaster_cls") &&
      disaster.disaster_cls === DisasterClass.T
    ) {
      return DisasterClass.TAB_ID_LIST.T;
    }
    return DisasterClass.TAB_ID_LIST.P;
  }
  isTraining() {
    return this.value === DisasterClass.T;
  }
  isProduction() {
    return this.value === DisasterClass.P;
  }
  toName() {
    return DisasterClass.NAMES[this.value];
  }
}
